/**
 * Our API server handles REST+Socket requests like storing data,
 * authenticating users, and serving up images.
 *
 * @type string
 */
export const SERVER_URL = process.env.VUE_APP_SERVER_URL || 'http://localhost:8072';

/**
 * Where our application sends someone to authenticate with Google
 *
 * @type string
 */
export const GOOGLE_AUTH_REDIRECT = process.env.VUE_APP_GOOGLE_AUTH_REDIRECT || `${SERVER_URL}/auth/google`;

/**
 * Where our API server redirects us after a successful Google auth
 *
 * @type string
 */
export const GOOGLE_AUTH_CALLBACK = process.env.VUE_APP_GOOGLE_AUTH_CALLBACK || location.href;

/**
 * Google Maps API key
 *
 * @type string
 */
export const GOOGLE_MAP_API = process.env.VUE_APP_GOOGLE_MAP_API || '';

/**
 * Where to redirect to after a successful logout
 *
 * @type string
 */
export const LOGOUT_REDIRECT = process.env.VUE_APP_LOGOUT_REDIRECT || '/';

/**
 * @type string
 */
export const STORAGE_KEY = 'chalkysticks-boilerplate';

/**
 * GLB model the trainer loads as its 3D pool table. Desktop and Quest
 * currently share the same optimized mesh; they are kept as separate constants
 * so the headset build can later diverge (e.g. a lighter model) without
 * touching call sites. Served from public/model, so the path is web-root
 * relative. TrainerLoader picks the right one via Config.Environment.
 *
 * @type string
 */
export const TRAINER_MODEL_DESKTOP = '/model/model-c-2048-avif-draco.glb';
export const TRAINER_MODEL_QUEST = '/model/model-c-2048-avif-draco.glb';
export const TRAINER_MODEL = TRAINER_MODEL_DESKTOP;

/**
 * When false, dynamic JSON-LD structured data injection is skipped after the
 * first pass. Useful when markup is already rendered server-side (SSR).
 *
 * @type boolean
 */
export const USE_DYNAMIC_JSONLD = !('cs_ssr' in window);

/**
 * When false, dynamic <meta> updates are skipped after the first pass. Useful
 * when meta tags are already rendered server-side (SSR).
 *
 * @type boolean
 */
export const USE_DYNAMIC_META = !('cs_ssr' in window);

/**
 * Build app version, injected at build time from package.json via
 * vue.config.js (process.env.VUE_APP_VERSION).
 *
 * @type string
 */
export const VERSION = process.env.VUE_APP_VERSION || '0.0.0';
